import {
  DIM2CLASS
} from '../core/icon-class';

require('./filter-dimensions.component.scss');

class FilterDimensionsController {
  constructor(
    $scope,
    CurrentFilterService,
    CurrentModelService,
    $rootScope,
    RouterService,
    ErrorHandlerService,
    FilterResource,
  ) {
    this.$scope = $scope;
    this.currentFilter = CurrentFilterService;
    this.filterBar = CurrentFilterService.filterBar;
    this.DIM2CLASS = DIM2CLASS;
    this.CurrentModelService = CurrentModelService;
    this.$rootScope = $rootScope;
    this.router = RouterService;
    this.FilterResource = FilterResource;
    this.ErrorHandlerService = ErrorHandlerService;

    this.openNodes = {};

    $scope.$on('aggregateLoaded', () => {
      this.currentFilter.rebuildVisibleDimensions();

    });
    $scope.$watch('$ctrl.model', () => {
      this.currentFilter.rebuildVisibleDimensions();
    });
    $scope.$watch('$ctrl.filter', () => {
      this.currentFilter.rebuildVisibleDimensions();
    });
    $scope.$watch('$ctrl.dim', () => {
      this.updateDim();
    });
    $scope.$watch('$ctrl.model', () => {
      this.updateDim();
    });
  }

  cleanCuts(dim) {
    if (!this.filter || !this.filter.filters) return;
    this.filter.filters = this.filter.filters.filter(cut =>
      !dim.toString().startsWith(cut.dimension.split('@')[0]));
    this.currentFilter.rebuildVisibleDimensions();
    this.router.filterChanged();
  }

  cleanHie(dim) {
    if (!this.filter || !this.filter.filters) return;
    this.filter.filters = this.filter.filters.filter(cut =>
      cut.dimension !== dim.toString());
    this.currentFilter.rebuildVisibleDimensions();
    this.router.filterChanged();
  }


  updateDim() {
    if (!this.model || !this.dim) {
      return;
    }
    const hie = this.model.getHierarchy(this.dim);
    if (hie.dimension) {
      this.openNode('hierarhy', hie.toString());
      this.openNode('dimension', hie.dimension.toString());
    } else {
      this.openNode('dimension', hie.toString());
    }
  }

  get panel() {
    return this.currentFilter.panel;
  }

  set panel(panel) {
    this.currentFilter.panel = panel;
  }

  get visibleDimensions() {
    return this.currentFilter.visibleDimensions;
  }

  set filter(filter) {
    this.currentFilter.filter = filter;
  }

  closeNode(type, obj) {
    this.openNodes[type] = false;
  }

  get filter() {
    return this.currentFilter.filter;
  }

  openNode(type, obj) {
    this.closeNode(type, obj);
    this.openNodes[type] = obj;
  }

  isNodeOpen(type, obj) {
    return this.openNodes[type] === obj;
  }

  select(dim) {
    this.router.barDim = dim.toString();
  }

  cutsForDim(dim) {
    return this.filter && this.filter.filters.filter(cut =>
      dim.toString().startsWith(cut.dimension.split('@')[0]));
  }

  cutsForHie(dim) {
    return this.filter && this.filter.filters.filter(cut =>
      cut.dimension === dim.toString());
  }
}

export function FilterDimensionsComponent() {
  return {
    restrict: 'E',
    template: require('./filter-dimensions.component.html'),
    scope: true,
    controller: FilterDimensionsController,
    controllerAs: '$ctrl',
    bindToController: {
      dim: '<',
      model: '<',
    },
  };
}



// WEBPACK FOOTER //
// ./src/filter/filter-dimensions.component.js